// Org-structure feature — query-key gyárak + a lista-szűrő típusok. A tényleges hívásokat a panelek a
// tipizált ts-rest kliensen (`api.orgDepartments` / `api.orgTeams` / `api.orgPositions`) intézik; a kulcsok
// itt élnek (cache-egységesítés). A `@atlas/contracts` a szerződés forrás-igazsága — itt csak kulcs-logika
// van (az invoices/service-catalog minta).
//
// HÁROM erőforrás (részleg → csapat → beosztás) → három külön kulcs-fa. A szintek KERESZT-ÉRVÉNYTELENÍTIK
// egymást: egy részleg átnevezése a csapat-listán feloldott `departmentName`-et is elavulttá teszi, egy
// csapat-változás pedig a beosztás-lista `teamName`/`teamColor`-át — ezért a form-sheetek a saját szintjük
// MELLETT az alattuk lévőket is invalidálják.

/** A lista-lekérdezés szűrői (a query-kulcs része — szűrő-/rendezés-váltás új cache-bejegyzést nyit).
 *  A `q` a szabad-szöveg (név/slug), a `sort` a rendezés-KULCS, az `order` az irány. */
export interface OrgListFilters {
  q: string;
  sort: string;
  order: 'asc' | 'desc';
}

/** Query-kulcs gyár a részleg-listához. */
export const departmentKeys = {
  all: ['org-departments'] as const,
  lists: () => ['org-departments', 'list'] as const,
  list: (filters: OrgListFilters) => ['org-departments', 'list', filters] as const,
  /** A csapat-űrlap részleg-választójának referencialistája (nagy limit, name ASC). */
  refs: () => ['org-departments', 'refs'] as const,
};

/** Query-kulcs gyár a csapat-listához. */
export const teamKeys = {
  all: ['org-teams'] as const,
  lists: () => ['org-teams', 'list'] as const,
  list: (filters: OrgListFilters) => ['org-teams', 'list', filters] as const,
  /** A beosztás-űrlap csapat-választójának referencialistája (nagy limit, name ASC). */
  refs: () => ['org-teams', 'refs'] as const,
};

/** Query-kulcs gyár a beosztás-listához. */
export const positionKeys = {
  all: ['org-positions'] as const,
  lists: () => ['org-positions', 'list'] as const,
  list: (filters: OrgListFilters) => ['org-positions', 'list', filters] as const,
};
